document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.key-ingredients-slider', {
    slidesPerView: 1.5,
    spaceBetween: 24,
    direction: 'horizontal',
    autoHeight: false,
    draggable: true,
    mousewheel: {
      forceToAxis: true
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'progressbar',
    },
    breakpoints: {
      850: {
        centeredSlides: false,
        slidesPerView: 2.3,
        spaceBetween: 28,
      },
      1150: {
        slidesPerView: 3.025,
      }
    },
    scrollbar: {
      el: '.key-ingredients-slider .swiper-scrollbar',
      draggable: true
    },
  })
})

